import React from "react";
const ComingSoonCard = ({ mainText, subText, imgUrl, imgWidth, children }) => {
  return (
    <div style={{ marginTop: 20 }}>
      <div
        style={{
          fontFamily: "MTNRegular",
          background: "#F6F6F6",
          textAlign: "center",
          borderRadius: 10,
          marginTop: 20,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          padding: 30,
        }}
      >
        <img width={imgWidth ? imgWidth : 250} src={imgUrl} />
        <p style={{ fontSize: 26, fontWeight: "bold" }}>{mainText}</p>
        <p style={{fontSize: 13, marginTop: -20 }}>{subText}</p>
        {children}
      </div>
    </div>
  );
};

export default ComingSoonCard;
